import React from 'react';
import { useAppContext } from '@/components/_shared/context/AppContext';
import styles from './Footer.module.scss';
import { useIntl } from 'react-intl';
import { FooterList } from './components/FooterList/FooterList';
import { SecondaryFooter } from './components/SecondaryFooter/SecondaryFooter';
import { getFooterLinks } from './data/footerData';

interface FooterProps {
  refTargets?: Record<string, () => void>;
}

export const Footer: React.FC<FooterProps> = ({ refTargets }) => {
  const { formatMessage } = useIntl();
  const { data: appContextData } = useAppContext();
  const domainUrl = appContextData.serverUrl;

  const { popularSearches, planEvents, findEvents, connectWithUs } = getFooterLinks(domainUrl);

  const navAriaLabel = formatMessage({ id: 'Site Navigation' });
  const useEventbriteText = formatMessage({ id: 'Use Eventbrite' });
  const planEventsText = formatMessage({ id: 'Plan Events' });
  const findEventsText = formatMessage({ id: 'Find Events' });
  const connectWithUsText = formatMessage({ id: 'Connect with Us' });

  return (
    <footer className={styles.listingsFooter} data-testid="footer">
      <div className={styles.footerContent}>
        <nav aria-label={navAriaLabel} className={styles.footerNav}>
          <FooterList id="use-eventbrite" heading={useEventbriteText} links={popularSearches} />
          <FooterList id="plan-events" heading={planEventsText} links={planEvents} />
          <FooterList id="find-events" heading={findEventsText} links={findEvents} />
          <FooterList id="connect-with-us" heading={connectWithUsText} links={connectWithUs} refTargets={refTargets} />
        </nav>
        <SecondaryFooter domainUrl={domainUrl} />
      </div>
    </footer>
  );
};
